'use strict';

// Assigned Dependencies

module.exports = (function() {    
    $('.ce-header').click(function(event) {       
        $(this).toggleClass('expanded');
        if ($(this).hasClass('expanded')) {
            $(this).find('span').addClass('icon-angle-up').removeClass('icon-angle-down');   
            moveWindowToElement($(this),0,800);       
        }
        else {
            $(this).find('span').addClass('icon-angle-down').removeClass('icon-angle-up');
        }

        $(this).parent().find('.ce-wrapper').slideToggle();
    });

    if ($('.font-icons-example').length > 0) {
        loadIconsReference();
    }

})();

function loadIconsReference() {
    $.ajax({
        url: 'assets/fonts/icons-reference.html',
        type: 'GET',                                
        success: function(d) {            
           $('.font-icons-example').append('<h4>Class Mapping</h4').append($(d).find('.css-mapping')).append('<h4>Character Mapping</h4').append($(d).find('.character-mapping'));
           $('.css-mapping').find('input').each(function() {
            var val ='class="icon-' + $(this).val() + '"';
            $(this).val(val);
           });
        },
        error: function(d) {    
            
        }
    });
}
